import { render } from "./Clients.vue?vue&type=template&id=2c027c78&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=2c027c78&scoped=true&lang=scss"
import "./Clients.vue?vue&type=style&index=1&id=2c027c78&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c027c78"]])

export default __exports__